import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'
import {SCHEMA_PLP} from '../../../constants'

const getItemListElements = (products) => {
    const newItemList = products.map((item, index) => ({
        '@type': SCHEMA_PLP.itemListElementType,
        position: index + 1,
        url: item.slugUrl || item.c_pdpLinks?.[0]?.url
    }))

    return newItemList
}

const Schema = ({products}) => {
    let schema = {}
    if (products) {
        schema = {
            '@context': SCHEMA_PLP.context,
            '@type': SCHEMA_PLP.type,
            itemListElement: getItemListElements(products)
        }
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    )
}

Schema.propTypes = {
    products: PropTypes.array
}

export default Schema
